import HCLTreeMxConnectionHandler from "./HCLTreeMxConnectionHandler";
import EventTreeEdge from "../../HCLTreeNode/EventTreeNode/EventTreeEdge";
import EventTreeVertex from "../../HCLTreeNode/EventTreeNode/EventTreeVertex";
import InitVertex from "../../HCLTreeNode/EventTreeNode/InitEvent/InitVertex";
import FunctionalEventVertex from "../../HCLTreeNode/EventTreeNode/FunctionalEventNode/FunctionalEventVertex";
import EventTreeFailureEdge from "../../HCLTreeNode/EventTreeNode/EventTreeFailureEdge";
import EventTreeMxGraph from "../EventTreeMxGraph";
import EndStateVertex from "../../HCLTreeNode/EventTreeNode/EndStateNode/EndStateVertex";
import EventTreeTransferGateVertex from "../../HCLTreeNode/EventTreeNode/EventTreeTransferGateNode/EventTreeTransferGateVertex";
import HCLTreeVertex from "../../HCLTreeNode/HCLTreeVertex";
import FunctionalEventSuccessPort
  from "../../HCLTreeNode/EventTreeNode/FunctionalEventNode/Port/FunctionalEventSuccessPort";
import FunctionalEventFailurePort
  from "../../HCLTreeNode/EventTreeNode/FunctionalEventNode/Port/FunctionalEventFailurePort";
import EventTreeSuccessEdge from "../../HCLTreeNode/EventTreeNode/EventTreeSuccessEdge";
import FunctionalEventPort from "../../HCLTreeNode/EventTreeNode/FunctionalEventNode/Port/FunctionalEventPort";
import {mxCell, mxGeometry} from "mxgraph-js"; // refer to the actual source code

class ESDMxConnectionHandler extends HCLTreeMxConnectionHandler {

  public constructor(graph: EventTreeMxGraph) {
    super(graph, ESDMxConnectionHandler.factoryMethod);
  }

  static factoryMethod(source: mxCell, target: mxCell, style: any): EventTreeEdge {
    if(HCLTreeMxConnectionHandler.doesPathExistBetween(source as HCLTreeVertex, target as HCLTreeVertex)) {
      throw new Error("Adding this edge will introduce a cycle");
    }

    if (target instanceof FunctionalEventPort) {
      throw new Error("No incoming edges for ports");
    }

    if (source instanceof FunctionalEventSuccessPort) {
      return ESDMxConnectionHandler.sourceFunctionalEventSuccessPortEdgeFactory(source, target as EventTreeVertex);
    }

    if (source instanceof FunctionalEventFailurePort) {
      return ESDMxConnectionHandler.sourceFunctionalEventFailurePortEdgeFactory(source, target as EventTreeVertex);
    }

    if (source instanceof InitVertex) {
      return ESDMxConnectionHandler.sourceInitVertexEdgeFactory(source, target as EventTreeVertex);
    }

    if (source instanceof EndStateVertex) {
      throw new Error("End States cannot contain outgoing edges");
    }

    if (source instanceof EventTreeTransferGateVertex) {
      throw new Error("Transfer gates cannot contain outgoing edges");
    }

    throw new Error("Cannot create edge for vertex of unknown type");
  }

  static sourceInitVertexEdgeFactory(source: InitVertex, target: EventTreeVertex): EventTreeEdge {
    if (target instanceof InitVertex) {
      throw new Error("Initiating events cannot contain any incoming edges");
    }
    if (source.getChildren().length > 0) {
      throw new Error("Initiating event cannot contain any more than one outgoing edge");
    }

    const edge = new mxCell('', new mxGeometry());
    edge.setEdge(true);
    edge.geometry.relative = true;
    return edge;
    // return new EventTreeEdge('', null, null);
  }

  static sourceFunctionalEventFailurePortEdgeFactory(source: FunctionalEventFailurePort, target: EventTreeVertex): EventTreeEdge {
    return new EventTreeFailureEdge();
  }

  static sourceFunctionalEventSuccessPortEdgeFactory(source: FunctionalEventSuccessPort, target: EventTreeVertex): EventTreeEdge {
    return new EventTreeSuccessEdge();
  }
}

export default ESDMxConnectionHandler;

